var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWhiteCross(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.2908 2.56066C21.8766 1.97487 21.8766 1.02513 21.2908 0.43934C20.705 -0.146447 19.7552 -0.146447 19.1695 0.43934L10.9999 8.60886L2.83041 0.43934C2.24463 -0.146447 1.29488 -0.146447 0.709093 0.43934C0.123306 1.02513 0.123306 1.97487 0.709093 2.56066L8.87861 10.7302L0.708871 18.8999C0.123085 19.4857 0.123085 20.4355 0.708871 21.0212C1.29466 21.607 2.24441 21.607 2.83019 21.0212L10.9999 12.8515L19.1697 21.0212C19.7555 21.607 20.7052 21.607 21.291 21.0212C21.8768 20.4355 21.8768 19.4857 21.291 18.8999L13.1213 10.7302L21.2908 2.56066Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhiteCross);
export default __webpack_public_path__ + "static/media/white-cross.f478dcda7a15b88f940cdd375fd05af1.svg";
export { ForwardRef as ReactComponent };